import type {EmailAddressee} from 'nutshell-core/types';

// Sort order for email addresses:
// 1. Peeps
// 2. Users
// 3. No-entity addresses
export function sortAddresseesByEntityType(recipients: EmailAddressee[]): EmailAddressee[] {
    return recipients.sort((a, b) => {
        // Filter no-entity addresses to end
        if (!a.entity && !b.entity) return 0;
        if (!a.entity) return 1;
        if (!b.entity) return -1;

        // Make sure Users are ordered after peeps
        if (a.entity.type === 'users' && b.entity.type !== 'users') return 1;
        if (a.entity.type !== 'users' && b.entity.type === 'users') return -1;

        return 0;
    });
}
